import { CityModel } from 'src/app/domain/models/city.model';

export interface CityState {
    citys: CityModel[];
}

export const initialCityState: CityState = {
    citys: [],
};
